import "react-toastify/dist/ReactToastify.css";

import {  
  Home,
  Menu,
  Support,
  Privacy,
} from "./Pages";
import { Cart, Footer, Header } from "./components";
import { Route, Routes } from "react-router-dom";
import {
  calculateCartTotal,
  // dispatchUsers,
  fetchFoodData,
  // fetchUserCartData,
  // isAdmin,
} from "./utils/functions";

import { AnimatePresence } from "framer-motion";
import Contact from "./components/Contact";
import { ToastContainer } from "react-toastify";
import { useEffect } from "react";
import { useStateValue } from "./context/StateProvider";

function App() {
  const [{ showCart,showContactForm, foodItems, cartItems }, dispatch] =
    useStateValue();

  useEffect(() => {
    fetchFoodData(dispatch); 
  }, [dispatch]);

  useEffect(() => {
    foodItems &&
      cartItems.length > 0 &&
      calculateCartTotal(cartItems, foodItems, dispatch);
  }, [cartItems, foodItems, dispatch]);
  return (
    <AnimatePresence exitBeforeEnter>
      <ToastContainer />
      <div className="w-screen h-auto min-h-[100vh] flex flex-col bg-primary">
        {showCart && <Cart />}
        {showContactForm && <Contact />} 
        <Header />
        <main 
          className={`mt-16 md:mt-16 px-3 md:px-8 md:py-6 py-4 w-full h-auto`}
          onClick={() => {}}
        >
          {/* Routes */}
          <Routes>
            <Route path="/*" element={<Home />} />  
            <Route path="/menu" element={<Menu />} /> 
            <Route path="/support" element={<Support />} /> 
            <Route path="/privacy" element={<Privacy />} /> 
          </Routes> 
          <Footer />
        </main>
      </div>
    </AnimatePresence>
  );
}

export default App;
